export default __webpack_public_path__ + "82e3b344f609a7c27b486f25c2b13be8.png";